import React, { Suspense } from 'react';
import { CenteredSpinner } from '@components/ui/feedback/CenteredSpinner';
import { useFeatureGate } from '@services/statsig';

import { lazyWithRetry } from '../../utils/lazyWithRetry';

// Lazy load both versions for code splitting and A/B testing
const EncounterViewV1 = lazyWithRetry(() => import('./components/v1/EncounterView'));
const EncounterViewV2 = lazyWithRetry(() => import('./components/v2/EncounterViewV2'));

/**
 * Encounter Page with A/B Testing
 *
 * Main entry point for viewing/editing encounters.
 * Feature gate: feature_encounter_view_v2
 * - v1: Legacy 3-column layout with selector buttons
 * - v2: New simplified 2-column layout with form fields
 */
export const EncounterPage: React.FC = () => {
  const isV2Enabled = useFeatureGate('feature_encounter_view_v2');

  return (
    <Suspense fallback={<CenteredSpinner />}>
      {isV2Enabled ? <EncounterViewV2 /> : <EncounterViewV1 />}
    </Suspense>
  );
};

export default EncounterPage;
